// extracted by mini-css-extract-plugin
export default {"google-button":"GoogleButton--google-button--oTGb8","googleButton":"GoogleButton--google-button--oTGb8"};